import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import TrackVisibility from "react-on-screen";
import colorSharp from "../assets/img/color-sharp.png";

const skillGroups = [
  {
    id: "frontend",
    label: "Frontend",
    accent: "#61DAFB",
    tags: ["React.js", "Next.js", "TypeScript", "JavaScript", "Tailwind CSS", "Material-UI", "HTML5", "CSS3", "Context API"],
  },
  {
    id: "backend",
    label: "Backend",
    accent: "#68D391",
    tags: ["Node.js", "NestJS", "Express.js", "REST APIs", "JWT Auth"],
  },
  {
    id: "database",
    label: "Database",
    accent: "#F6AD55",
    tags: ["PostgreSQL", "MongoDB", "Firebase Firestore"],
  },
  {
    id: "cloud",
    label: "Cloud & DevOps",
    accent: "#76E4F7",
    tags: ["GCP", "Firebase Cloud Functions", "Docker", "CI/CD (GitHub Actions)"],
  },
  {
    id: "ai",
    label: "AI & Analytics",
    accent: "#B794F4",
    tags: ["OpenAI API", "Langfuse", "Metabase", "PostHog", "Segments.io"],
  },
  {
    id: "tools",
    label: "Tools",
    accent: "#FC8181",
    tags: ["Git", "Postman", "JIRA", "VS Code"],
  },
];

export const Skills = () => {
  return (
    <section className="skill" id="skills">
      <Container>
        <Row>
          <Col xs={12}>
            <TrackVisibility partialVisibility once>
              {({ isVisible }) => (
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                  <h2 className="skill-heading">Skills</h2>
                  <p className="skill-subtitle">
                    A curated stack of technologies I use to build production-grade
                    full-stack products — from pixel-perfect frontends to scalable
                    cloud backends.
                  </p>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>

        <Row className="skill-groups-grid g-4">
          {skillGroups.map((group, gi) => (
            <Col key={group.id} md={6} lg={4}>
              <TrackVisibility partialVisibility once>
                {({ isVisible }) => (
                  <div
                    className={`skill-group${isVisible ? " animate__animated animate__fadeInUp" : ""}`}
                    style={{ "--group-accent": group.accent, animationDelay: `${gi * 80}ms` }}
                  >
                    <div className="skill-group-header">
                      <span className="skill-group-dot" style={{ background: group.accent }} />
                      <h5 className="skill-group-label">{group.label}</h5>
                    </div>
                    <div className="skill-tags">
                      {group.tags.map((tag, ti) => (
                        <span
                          key={ti}
                          className="skill-tag"
                          style={{ "--tag-accent": group.accent }}
                        >
                          {tag}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
              </TrackVisibility>
            </Col>
          ))}
        </Row>
      </Container>
      <img className="background-image-left" src={colorSharp} alt="" />
    </section>
  );
};
